import { FC } from 'react'

interface MoonshotSVGProps {
  height?: number
  width?: number
  className?: string
}

/**
 * Crescent-moon badge for Moonshot AI (Kimi) — a generic, non-trademarked
 * moon glyph (Tabler's IconMoon path) rather than an exact logo
 * reproduction we don't have on hand.
 */
export const MoonshotSVG: FC<MoonshotSVGProps> = ({ height = 40, width = 40, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
    >
      <rect width="40" height="40" rx="8" fill="#0F172A" />
      <g transform="translate(8, 8)" stroke="#ffffff" strokeWidth="1.75" fill="none">
        <path
          d="M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454l0 .008"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
